/* unplugin-vue-components disabled */import script from "./message-location.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-location.vue?vue&type=script&lang=ts&setup=true"

import "./message-location.vue?vue&type=style&index=0&id=3d38c7ea&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d38c7ea"]])

export default __exports__